
export class AuthorityVm{
    Id: number = 0;
    AuthorityCode: string = "";
    AuthorityName: string = "";
    PlaceOfIssue: string = "";
    Address: string = "";
    PostalCode: string = "";
    City: string = "";
    PoliceDistrict: string = "";
    KKCode: string = "";
    PCode: string = "";
    MailAddress: string = "";
    IsActive: boolean = true;
}